import styled from "styled-components";
import { Box } from "theme-ui";

interface CustomProps {
  $active?: boolean;
}

export const DropdownWrapper = styled.div`
  position: relative;
`;
export const DropdownMenu = styled(Box)<CustomProps>`  
  z-index: 1000;
  margin: 0;
  list-style: none;
  position: absolute;    
  width: 125px;
  min-width: 125px;  
  width:125px;
  min-width:125px;
  border-radius: 4px;
  padding:10px;
  border: 1px solid #EBEBEB;
  background: #FFF;
  box-shadow: 0px 84px 23px 0px rgba(0, 0, 0, 0.00), 0px 53px 21px 0px rgba(0, 0, 0, 0.01), 0px 30px 18px 0px rgba(0, 0, 0, 0.03), 0px 13px 13px 0px rgba(0, 0, 0, 0.04), 0px 3px 7px 0px rgba(0, 0, 0, 0.05);
`;

export const DropdownItem = styled.button`
  cursor: pointer;
  color: #000;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 5px;
  display: block;
  width: 100%;
  clear: both;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;

  &:hover{
    background-color: #EBEBEB;
  }
  &:last-child{
    margin-bottom:0;
  }
  &:focus{
    color:black;
  }
`;